// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader[data-v-6631b022]{text-align:center;transform:translateY(-80px);margin-top:50vh}.loader__title[data-v-6631b022]{font-size:3.75rem;font-weight:700}.loader__progress[data-v-6631b022]{display:inline-block;max-width:600px;width:80%}", ""]);
// Exports
module.exports = exports;
